import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SiteVisitForm from '../components/investor/SiteVisitForm';
import LandAllotmentForm from '../components/investor/LandAllotmentForm';
import VirtualMeetingForm from '../components/investor/VirtualMeetingForm';

const TabButton = ({ active, onClick, children }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm md:text-base transition-colors duration-200 ${
      active 
        ? 'text-purple-700 border-b-2 border-purple-700' 
        : 'text-gray-600 hover:text-purple-600'
    }`}
  >
    {children}
  </button>
);

const InvestorPage = () => {
  const [activeTab, setActiveTab] = useState('siteVisit');

  return (
   <div className="mx-auto px-6 py-10 max-w-screen-2xl">
  <h1 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-3">
    Connect With Our Investment Team
  </h1>
  <p className="text-center text-gray-600 mb-10 max-w-3xl mx-auto text-lg">
    We're here to help you with your investment needs. Choose an option below to get started.
  </p>

  <div className="bg-white rounded-xl shadow-xl overflow-hidden mb-10">
    <div className="border-b border-gray-200">
      <nav className="flex flex-wrap gap-2 md:gap-4 px-4 md:px-6 py-3">
        <TabButton active={activeTab === 'siteVisit'} onClick={() => setActiveTab('siteVisit')}>
          Site Visit
        </TabButton>
        <TabButton active={activeTab === 'landAllotment'} onClick={() => setActiveTab('landAllotment')}>
          Land Allotment
        </TabButton>
        <TabButton active={activeTab === 'virtualMeeting'} onClick={() => setActiveTab('virtualMeeting')}>
          Virtual Meeting
        </TabButton>
      </nav>
    </div>

    <div className="p-8">
      {activeTab === 'siteVisit' && <SiteVisitForm />}
      {activeTab === 'landAllotment' && <LandAllotmentForm />}
      {activeTab === 'virtualMeeting' && <VirtualMeetingForm />}
    </div>
  </div>
</div>

  );
};

export default InvestorPage;
